import { createContext } from "react"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

export type ProductSheetGroup =
  OrganizationsResponses.OrganizationSettings["displaySettings"][number]

export type ProductSheetGroupContextType = {
  selectedProductSheetGroup: ProductSheetGroup | null | undefined
  setSelectedProductSheetGroup: (
    productSheetGroup: ProductSheetGroup | null | undefined
  ) => void
}

export const ProductSheetGroupContext = createContext<
  ProductSheetGroupContextType | undefined
>(undefined)
